import {KeyWordSearchService} from "./KeyWordSearchService";
import {KeyWordServiceUtility} from "../Utility/KeyWordServiceUtility";
import {SearchType} from "../Model/SearchType";


export class KeyWordSuggestSearchService extends KeyWordSearchService {

	constructor() {
		super();

	}

	/**
		 *检查参数 
		 * @return 
		 */
	CheckParams() {
		if(super.CheckParams()==false)return false;
		return true;
	}

	/**
	 * 查询
	 * @param {*} succeedCallback 
	 * @param {*} errorCallback 
	 */
	Query(succeedCallback, errorCallback) {
		super.queryType=SearchType.CommonSuggest;

		let queryService=new KeyWordServiceUtility();
		super.SetBaseInfoServiceUtility(queryService);
		queryService.Query(succeedCallback, errorCallback);
	}


}
